import type { DataViewFilters } from '@/services/types'
import api from '@/services/api'
import { Videos } from '@/services/videos/types'
import { AiLanguagesResponse, AiPendingProposalsResponse, AiVideoStatusResponse, AiVoicesResponse, GenerateAiVideoForm } from '@/services/ai-generated/types'

const getAiGenerated = async (params?: DataViewFilters): Promise<Videos> => {
  const response = await api.get<Videos>('/videos', {
    params: { ...params, source_type: 'ai_generated', show_public: false }
  })
  return response.data
}

const createAiGeneratedVideo = async (body: GenerateAiVideoForm): Promise<void> => {
  const response = await api.post('/videos/ai-videos', body)
  return response.data
}

const getAiVideoStatus = async (): Promise<AiVideoStatusResponse> => {
  const response = await api.get<AiVideoStatusResponse>('/videos/ai-videos/status')
  return response.data
}

const getPendingAiGenerated = async (params?: DataViewFilters): Promise<AiPendingProposalsResponse> => {
  const response = await api.get<AiPendingProposalsResponse>('/publisher/packages/proposals/ai', {
    params
  })
  return response.data
}

const getAiVoices = async (): Promise<AiVoicesResponse> => {
  const response = await api.get<AiVoicesResponse>('/videos/ai-videos/voices')
  return response.data
}

const getAiVideoLanguages = async (): Promise<AiLanguagesResponse> => {
  const response = await api.get<AiLanguagesResponse>('/videos/ai-videos/languages')
  return response.data
}

export default { getAiGenerated, createAiGeneratedVideo, getAiVideoStatus, getPendingAiGenerated, getAiVoices, getAiVideoLanguages }
